<template>
    <x-card class="panel">
        <x-card-title>
            <x-layout align-items-center mb-3>
                <x-flex>
                    <h3 class="font-weight-regular">Client</h3>
                </x-flex>

                <x-flex text-xs-right>
                    <x-btn
                        v-if="$root.userIsBrokerAdmin()"
                        class="ma-0"
                        @click="openClientDialog(false)"
                    >
                        Create new client
                    </x-btn>
                </x-flex>
            </x-layout>
        </x-card-title>

        <x-card-text>
            <x-layout>
                <x-flex xs12>
                    <x-autocomplete
                        v-model="selectedClientId"
                        :items="clients"
                        label="Select Client"
                        placeholder="Select a Client"
                        item-text="name"
                        item-value="id"
                        append-icon="keyboard_arrow_down"
                    />
                </x-flex>
            </x-layout>

            <template v-if="selectedClient">
                <x-layout mb-3>
                    <x-flex>
                        <data-list v-model="clientData" class="my-4"/>
                    </x-flex>
                </x-layout>

                <x-layout>
                    <x-flex class="text-xs-right">
                        <x-btn
                            class="wide ma-0"
                            @click="openClientDialog(true)"
                        >
                            Edit client
                        </x-btn>
                    </x-flex>
                </x-layout>
            </template>
        </x-card-text>

        <x-dialog v-model="showClientForm" persistent width="800" content-class="overflow-scroll">
            <client-form
                v-if="showClientForm"
                :client-company="selectedClient"
                :edit="isEditing"
                @close="showClientForm = false"
                @clientUpdated="$emit('clientUpdated')"
            />
        </x-dialog>
    </x-card>
</template>

<script>
import DataList from "../../components/Shared/UIComponents/DataList.vue";
import ClientForm from "../../components/Broker/Client/ClientForm.vue";

export default {
    name: "ClientManager",
    components: {
        ClientForm,
        DataList
    },
    props: {
        clients: {
            type: Array,
            required: true
        },
        value: {
            type: Number,
            required: false,
            default: null,
        }
    },
    data() {
        return {
            selectedClientId: null,
            showClientForm: false,
            isEditing: false,
        }
    },
    created() {
        this.selectedClientId = this.value;
    },
    methods: {
        openClientDialog(isEdit) {
            this.isEditing = isEdit;
            this.showClientForm = true;
        }
    },
    watch: {
        selectedClientId() {
            this.$emit('input', this.selectedClientId);
        }
    },
    computed: {
        selectedClient() {
            return this.clients.find(client => client.id === this.selectedClientId);
        },
        clientData() {
            const data = this.selectedClient;
            return [
                {
                    text: 'Client name',
                    value: data.name
                },
                {
                    text: 'Building number',
                    value: data.address?.line3
                },
                {
                    text: 'Address line 1',
                    value: data.address?.line1
                },
                {
                    text: 'Address line 2',
                    value: data.address?.line2
                },
                {
                    text: 'City/Town',
                    value: data.address?.city
                },
                {
                    text: 'Post code',
                    value: data.address?.postcode
                },
                {
                    text: 'Country',
                    value: data.address?.country?.name
                },
                {
                    text: 'Latitude',
                    value: data.address?.latitude
                },
                {
                    text: 'Longitude',
                    value: data.address?.longitude
                },
                {
                    text: 'DUNS Reference',
                    value: data.address?.duns_ref
                },
                {
                    text: 'Company type',
                    value: _.upperFirst(data.company_type)
                },
                {
                    text: 'Status',
                    value: 'Active'
                },
            ];
        }
    }
}
</script>

<style scoped lang="scss">
    .main-container {
        background: black;
        border-radius: 5px;
    }
    .align-items-center {
        align-items: center;
    }
    .flex-column {
        flex-direction: column;
    }
</style>
